import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStationList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.94 1.54a.26.26 0 0 1 .278 0l4.968 3.218c.076.05.122.136.123.229V9.7h1.727c.145 0 .263.122.263.271v3.28h2.803c.288 0 .523.241.523.54v6.667c0 .298-.235.54-.523.541H2.024a.534.534 0 0 1-.524-.54V13.79c0-.298.235-.54.524-.54h2.802V9.971c0-.149.117-.271.262-.271h1.714V4.988c0-.093.047-.18.124-.23zm-.873 12.815c-.796 0-1.442.621-1.442 1.387v3.488H14.5v-3.488c0-.766-.646-1.387-1.442-1.387zm.873-9.368c-1.087 0-1.967.907-1.967 2.027s.88 2.028 1.967 2.028c1.085 0 1.967-.909 1.967-2.028 0-1.12-.881-2.027-1.967-2.027" })
});
export default SvgStationList;
